/**
 * modify-security-questions-server-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { IncomingMessage } from "../../general/incoming-message";
import { MessageTag } from "../../message-tag";

export class ModifySecurityQuestionsServerRequest extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.SREQ_MODIFY_SECURITY_QUESTIONS;
	public static tag : MessageTag = MessageTag.SREQ_MODIFY_SECURITY_QUESTIONS;

  /**
   * The number of security questions that are necessary to satisfy this zone's
   * minimum requirement.
   */
  public required : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/modify-security-questions-server-request.ts